import { Component, InjectionToken } from '@angular/core';
import { SharingDataService } from 'src/sharing-data.service';
import { ViewCartService } from './view-cart.service';
import { ViewProductService } from '../view-products/view-product.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/AuthService';
import { Order } from '../order/order.model';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-view-cart',
  templateUrl: './view-cart.component.html',
  styleUrls: ['./view-cart.component.css']
})

export class ViewCartComponent {

   ngAfterViewInit() {
    // This executes right after the HTML hits the screen
    setTimeout(() => {
      // Fake a window resize event to force the browser to snap the header and banner together
      window.dispatchEvent(new Event('resize'));
    }, 50); // A 50ms delay is invisible to the user but enough for the browser
  }
  constructor(private sharingData: SharingDataService,private viewCartService :ViewCartService,
    private viewProductService :ViewProductService,private router: Router,
    private authService : AuthService,private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.getCustId();
    this. ViewOrdersByCustomerId();
    this.sharingData.currentValue.subscribe(val => {
      console.log('Received:', val);

      this.onCartClick();
      
  
    });
    
    this.totAmt=0;
    this.Amount=false;
    
     this.sharingData.loggedInCustomerIdVal.subscribe(val => {
    console.log('Received in Component B:', val);
    this.customerId=val
    if(this.customerId!=null || this.customerId!=undefined || this.customerId == 0){
       // this.viewCartByCustomerId();
    }
    
      
  });

  }
  showModalProceed=false;
  cartExist=false;
  Amount=false;
  viewProductsInCart:any;
  customerId:number=0;
  customerCart:any;
  paymentsPage=false;
  customerLoggedIn=false;
  totAmt:number=0;
  Ordered:boolean=false;
  onCartClick(){
    this.getLocalCartDetails();
  }
  getCustId(){
    this.customerId=Number(localStorage.getItem('customerId'));
    console.log("CustomerId in view cart ngonit",this.customerId);
    if(this.customerId != null && this.customerId != undefined && this.customerId != 0){
      this.customerLoggedIn=true;
     console.log("customerLoggedIn",this.customerLoggedIn);
    }
    else {

     this.customerLoggedIn=false;
      console.log("customerLoggedIn",this.customerLoggedIn);
    }
  }
  ViewProductsInCart(){
    this.viewCartService.ViewCart().subscribe({
      next:(response) => {
      
        this.viewProductsInCart=response;
        console.log('View Cart:', this.viewProductsInCart);
      },
      error: (err) => {
        console.error('Error:', err);
      }
    });
  }

  getLocalCartDetails(){
    this.totAmt=0;
     let token=this.authService.getToken();
      console.log("Token is ",token);
      if(token == null && token == undefined){
      this.sharingData.getlocalCart.subscribe(val => {
        console.log('Received:', val);
      this.customerCart=val;
      let cartVal=this.customerCart.length;
      if(cartVal > 0){
         this.cartExist=true; 
      }
     setTimeout(() =>{let value=0;
      for(let i=0;i<this.customerCart.length;i++){
         value=0;
         value=localStorage.getItem('discountedPrice') ? Number(localStorage.getItem('discountedPrice')) : this.totAmt;
        this.customerCart[i].productPrice=value
        console.log('localStorage. discountedPrice',localStorage.getItem('discountedPrice'));
        console.log('discountedPrice',this.customerCart[i].discountedPrice);
        console.log('value',value);
         console.log('Receivedddddddddddddddddddddddd');
          let quan=this.customerCart[i].Quantity;
          let disPrice=this.customerCart[i].discountedPrice;
            console.log('Quantuty',quan);
           this.totAmt=Number(disPrice) + this.totAmt;
           console.log('Total Amount',this.totAmt);
        // value=0;
        // value=Number(this.customerCart[i].productPrice);
        // this.totAmt=localStorage.getItem('discountedPrice') ? Number(localStorage.getItem('discountedPrice')) : this.totAmt;
         console.log('Receivedddddddddddddddddddddddd');
            // this.totAmt=value + this.totAmt;
            
        }
        console.log('Total Amount',this.totAmt)
      },0);
      });
       
      }
      else {
        console.log('In else part of viewcart');
            this.viewCartByCustomerId();
      }
       
   

  }

  DeleteFromCartApiCall(product:any){
    console.log('Delete product from cartttt',product);
    this.customerId=Number(localStorage.getItem('customerId'));
    if (this.customerId == null || this.customerId == undefined || this.customerId == 0) {
   let cartItems = JSON.parse(localStorage.getItem('cart') || '[]');
   console.log('cartItems cartttt',product);
   const updatedCart = cartItems.filter((item: any) => item.productId !== product.productId);
  localStorage.setItem('cart', JSON.stringify(updatedCart));
  this.sharingData.getlocalStorageCart(updatedCart);
  setTimeout(() =>{this. getLocalCartDetails()},0);
  this.cdr.detectChanges();
  // this.totAmt=0;
  console.log('Updated cartttt',updatedCart);
//  setTimeout(()=>{this.totAmt=this.totAmt - Number(updatedCart.productPrice)},0);;
}
else {
   console.log('In else part of delete');
    this.viewProductService.DeleteFromCart(product.cartId).subscribe({
       
      next:(response) => {
        console.log('Product deleted from Cart :', response);
        this.viewCartByCustomerId();
      },
      error: (err) => {
        console.error('Error:', err);
      }
    });
   
 }
  
  }

  loginWithOtp(){
    this.router.navigate(['/login']);
  }

  displayDiscountedPrice:any;
  viewCartByCustomerId(){
     
     this.totAmt=0;
    let token=this.authService.getToken();
    
      console.log("Token is ",token);
      if(token != null || token != undefined){
        this.customerId=Number(localStorage.getItem('customerId'));
    this.viewCartService.viewCartByCustomerId(this.customerId).subscribe({
       next:(response) => {
        this.customerCart=response;
           let value=0;
          let carLen=this.customerCart.length;
          if(carLen > 0){
             this.cartExist=true; 
          }
       setTimeout(() =>{for(let i=0;i<this.customerCart.length;i++){
        value=0;
        // value=localStorage.getItem('discountedPrice') ? Number(localStorage.getItem('discountedPrice')) : this.totAmt;
        //this.customerCart[i].productPrice=value
         console.log('Receivedddddddddddddddddddddddd');
          
           console.log('discountedPrice',this.customerCart[i].discountedPrice);
          
          
            this.Amount=true;
            this.customerCart[i].cartId == this.carIdInOrder;
            this.carIdInOrder=localStorage.getItem('carIdInOrder');
             console.log('this.customerCart[i].cartStatus',this.customerCart[i].cartStatus);
          
              if(this.customerCart[i].cartStatus === "Ordered"){
              console.log('In if condition of ordered');
              this.Ordered=true;
               //this.totAmt=this.totAmt-Number(this.customerCart[i].discountedPrice);
             console.log('this.totAmt',this.totAmt);
            } else{
              console.log('In else condition of ordered');
              this.Ordered=false;
               this.totAmt=this.totAmt+Number(this.customerCart[i].discountedPrice);
             console.log('this.totAmt',this.totAmt);
            }
          console.log('this.Ordered',this.Ordered);
              // this.totAmt=value + this.totAmt;
            console.log('customer cart after splice',this.customerCart);
        }
        // this.customerCart = this.customerCart.filter((cart:any) => this.carIdInOrder==(cart.cartId));
        console.log('Total Amount',this.totAmt)
       
      },0);
        // let totString=this.totAmt.toString();
        // if(totString.charAt(0) == '0'){
        //  totString= totString.substring(1);
        //  this.totAmt=Number(totString);
        // }
        console.log('Total Amount',this.totAmt)
        console.log('View Cart', response);
      
      },
    })
  }
  }
addressDetailsByCustomerId:any;
     proceedToCheckout() {

       console.log(" new Orders button clicked", this.myOrdersByCustomerId);
      let token=this.authService.getToken();
      console.log("Token is ",token);
      if(token == null || token == undefined){
           this.loginWithOtp();
      }
      else{
       this.customerId= Number(localStorage.getItem('customerId'));
            this.sharingData.getOrderbyCustomerId(this.customerId).subscribe({
      next:(response) => {
      
        this.myOrdersByCustomerId=response;
      
        console.log('View Cart by CustomerId :', this.myOrdersByCustomerId);
         for(let i=0;i<this.myOrdersByCustomerId.length;i++){
                 if((this.myOrdersByCustomerId[i] != null && this.myOrdersByCustomerId[i] != undefined && this.myOrdersByCustomerId.length > 0 && this.myOrdersByCustomerId[i].cart.cartStatus != "Ordered") || this.myOrdersByCustomerId[i].paymentStatus != "Paid"){
        this.paymentsPage = true;
     
     this.sharingData.getAddressByCustomerId(this.customerId).subscribe({
      next:(response) =>{
         console.log('Address Details',response);
          this.addressDetailsByCustomerId=response;
           if(this.addressDetailsByCustomerId[0] != null && this.addressDetailsByCustomerId[0] != undefined){
    this.router.navigate(['/payment']);
    }
     else {
        this.router.navigate(['/address']);
     }

      }
    })
    ;
   
       }
        else
       {
        alert("Please add products to cart to proceed to checkout");
       }
              
              }
      },
      error: (err) => {
        console.error('Error:', err);
      }
    });
  
    
      }
  
  }
 product:any;
 order:Order={
  cartId:0,
  CustomerId:0,
 status:'',
 paymentStatus:'',
 productPrice:'',
 totalAmount:'',
 orderDate:new Date()


 };
 carIdInOrder:any
 orderL:any;
  myOrdersByCustomerId:any;
    cartId:number=0;
 UpdateCart(selectedOrder:any){
  
  let updateCartItem;
  updateCartItem=selectedOrder
  updateCartItem.cartStatus='Ordered';
  this.sharingData.updateCartFn(updateCartItem).subscribe({
    next:(response) => {
     console.log('Cart updated',response);
     
     this.viewCartByCustomerId();
    }
    });
 }

  AddToOrder(selectedOrder:any){
    const orderItems=[];
    this.product=selectedOrder;
    console.log("Selected order",this.product);
    this.order.cartId=this.product.cartId;
    this.order.CustomerId=this.product.customer.CustomerId;
    this.order.orderDate=new Date();
    this.order.status="In Cart";
    this.order.paymentStatus="Not Paid";
    this.order.totalAmount=this.product.discountedPrice;
     orderItems.push(this.order)
    console.log("payload order",orderItems);
   this.sharingData.addOrderFn(orderItems).subscribe({
    next:(Response) =>{
      this.orderL=Response;
         console.log('order added',Response)
         for(let i=0;i<this.orderL.length;i++){
           this.carIdInOrder=this.orderL[i].cart.cartId;
         }
         localStorage.setItem('carIdInOrder',this.carIdInOrder);
          console.log('carIdInOrder',this.carIdInOrder);

         this.UpdateCart(selectedOrder);
    }
   })
  }

  closeModal() {
    this.showModalProceed = false;
  }

  ViewOrdersByCustomerId(){
     let token=this.authService.getToken();
      console.log("Token is ",token);
      if(token != null || token != undefined){
       this.customerId= Number(localStorage.getItem('customerId'));
            this.sharingData.getOrderbyCustomerId(this.customerId).subscribe({
      next:(response) => {
      
        this.myOrdersByCustomerId=response;
      
        console.log('View Cart by CustomerId :', this.myOrdersByCustomerId);
      },
      error: (err) => {
        console.error('Error:', err);
      }
    });
      } 
      else {
       
      }
   
  }

}
